import React from 'react';
import { ColorOptions } from '../../../types/colorOptions';
import { Link } from '@tanstack/react-router';
import { isExternalLink } from '../../../hooks/isExsternalLink';

export interface ReactLinkProps {
	label?: string;
	url?: string;
	icon?: React.ReactNode;
	className?: string;
	children?: React.ReactNode | React.ReactNode[];
	options?: ColorOptions;
}

export const ReactLink = ({
	label,
	url,
	icon,
	className,
	children,
}: ReactLinkProps) => {
	const isExternal = isExternalLink(url ?? '');
	const content = children ? (
		children
	) : (
		<>
			{icon && <span>{icon}</span>}
			{label}
		</>
	);

	if (isExternal) {
		return (
			<a
				href={url}
				target="_blank"
				rel="noopener noreferrer"
				className={className}
			>
				{content}
			</a>
		);
	}

	return (
		<Link to={url} className={className}>
			{content}
		</Link>
	);
};
